import { useMemo } from "react";
import { Link, useSearchParams } from "react-router-dom";

const RESULT_COPY = {
  success: {
    className: "pay-status--paid",
    title: "Оплату прийнято",
    body: "Дякуємо! Статус підписки оновиться після підтвердження від Monobank.",
  },
  pending: {
    className: "pay-status--pending",
    title: "Оплата в обробці",
    body: "Платіж ще обробляється. Перевірте статус на сторінці оплати через кілька хвилин.",
  },
  failure: {
    className: "pay-status--failed",
    title: "Оплату не завершено",
    body: "Платіж не пройшов або був скасований. Спробуйте ще раз зі сторінки оплати.",
  },
  unknown: {
    className: "pay-status--pending",
    title: "Результат оплати",
    body: "Перевірте статус підписки на сторінці оплати.",
  },
};

function normalizeResultStatus(raw) {
  const value = String(raw || "").toLowerCase();
  if (["success", "ok", "paid"].includes(value)) return "success";
  if (["pending", "processing", "created"].includes(value)) return "pending";
  if (["failure", "failed", "error", "cancel", "cancelled", "canceled"].includes(value)) {
    return "failure";
  }
  return "unknown";
}

function PaymentResultContent() {
  const [searchParams] = useSearchParams();
  const statusKey = useMemo(
    () => normalizeResultStatus(searchParams.get("status") || searchParams.get("result")),
    [searchParams],
  );
  const copy = RESULT_COPY[statusKey] || RESULT_COPY.unknown;

  return (
    <div className="pay-shell" data-testid="payment-result-screen">
      <div className={`pay-status ${copy.className}`} data-testid={`payment-result-${statusKey}`}>
        <i className="fa-solid fa-receipt" aria-hidden="true" />
        <span>{copy.title}</span>
      </div>
      <p>{copy.body}</p>
      <Link to="/profile/billing" className="action-btn action-btn--primary" data-testid="payment-result-billing-link">
        Перейти до оплати
      </Link>
    </div>
  );
}

export default PaymentResultContent;
